import { render, staticRenderFns } from "./OverviewTabs.vue?vue&type=template&id=56d5e16e&scoped=true&"
import script from "./OverviewTabs.vue?vue&type=script&lang=js&"
export * from "./OverviewTabs.vue?vue&type=script&lang=js&"
import style0 from "./OverviewTabs.vue?vue&type=style&index=0&id=56d5e16e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d5e16e",
  null
  
)

export default component.exports